import React from 'react';
import { IQRCodeScanDetector } from './eiq-secure-qr-code-scan-detector.types';
import { startEndChar } from 'common/helpers/eiq-passport.helper';

const timeBeforeScanCheck = 100;
const minLength = 8;
const maxTimeByChar = 30;
const endKeys = new Set(['Enter', 'Tab', '\n', '\r', '\r\n']);

class QRCodeScanDetector extends React.PureComponent<IQRCodeScanDetector> {
  private timer: ReturnType<typeof setTimeout> | null = null;
  private resultString = '';
  private firstCharTime = 0;
  private lastCharTime = 0;
  private isScanning = false;

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.reset();
  }

  private reset = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    this.resultString = '';
    this.firstCharTime = 0;
    this.lastCharTime = 0;
    this.isScanning = false;
  };

  private startScanning = (time: number) => {
    this.reset();

    this.isScanning = true;
    this.firstCharTime = time;
    this.lastCharTime = time;

    this.restartTimer();
  };

  private restartTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(this.finishScanning, timeBeforeScanCheck);
  };

  private finishScanning = () => {
    if (!this.isScanning) {
      return;
    }

    const value = this.resultString;
    const scanDuration = this.lastCharTime - this.firstCharTime;

    const isValidLength = value.length >= minLength;
    const isFastEnough = scanDuration <= value.length * maxTimeByChar;

    const { onScan } = this.props;

    if (isValidLength && isFastEnough && onScan) {
      onScan(value);
    }

    this.reset();
  };

  private handleKeyDown = (event: KeyboardEvent) => {
    const { key } = event;
    const currentTime = Date.now();

    if (!this.isScanning) {
      if (key !== startEndChar) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      this.startScanning(currentTime);
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (key === startEndChar) {
      this.lastCharTime = currentTime;
      this.finishScanning();
      return;
    }

    if (endKeys.has(key)) {
      this.lastCharTime = currentTime;
      this.finishScanning();
      return;
    }

    if (key.length !== 1) {
      return;
    }

    this.resultString += key;
    this.lastCharTime = currentTime;

    this.restartTimer();
  };

  render() {
    return null;
  }
}

export default QRCodeScanDetector;
